import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NkCardListItemAbstractComponent } from '@nk/ui-lib';
import { SCREENING_STATUS_TAG_CSS_CLASSES, SCREENING_STATUS_TAG_ICONS } from '../../utils/screening-case.utils';
import { SCREENING_STATUS_TAGS_TRANSLATIONS, ScreeningStatusTag } from '../../utils/screening-overview.utils';

@Component({
  selector: 'nk-screening-case-card-status-list-item',
  imports: [TranslateModule],
  templateUrl: './screening-case-card-status-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCaseCardStatusListItemComponent<
  T extends { screeningStatusTags: ScreeningStatusTag[] },
> extends NkCardListItemAbstractComponent<T, 'screeningStatusTags'> {
  public statusTags = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity) {
      const item = value.entity[value.prop];
      if (item) {
        return item;
      }
    }
    return [];
  });

  public translations = SCREENING_STATUS_TAGS_TRANSLATIONS;
  public cssClasses = SCREENING_STATUS_TAG_CSS_CLASSES;
  public icons = SCREENING_STATUS_TAG_ICONS;
}
